import { render, staticRenderFns } from "./notificaciones-oeb.vue?vue&type=template&id=11b4b3b6&scoped=true"
import script from "./notificaciones-oeb.vue?vue&type=script&lang=js"
export * from "./notificaciones-oeb.vue?vue&type=script&lang=js"
import style0 from "./notificaciones-oeb.vue?vue&type=style&index=0&id=11b4b3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4b3b6",
  null
  
)

export default component.exports